
$(document).ready(function(){

    $(".faq-btn").click(function(){

      debugger;
      // this = the btn | icon & bg changed
      this.classList.toggle("is-open");

      // the faq-content
      const content = this.nextElementSibling;

      // IF open, close | else open
      if (content.style.maxHeight) content.style.maxHeight = null;
      else content.style.maxHeight = content.scrollHeight + "px";
    });
  
  
  var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  
  
  
  //Slider hack
  if ($(window).width() < 768) {
   	$(".home-slideshow .images-contain .slide-image").removeAttr("data-href");
  }
  else {
    //debugger;
    //$('.slideshow > .images-contain > .slide-image').each(function () { $(this).addClass('remove') });
  }
   
 
});


$(function() {
  $( "#ContactFormBirthday" ).datepicker();
  $( "#ContactFormBirthdayMain" ).datepicker();
  
  $('#slideshow-1618411829b44ac36a > .container-fluid > .row > .init-slider > .slideshow > .item').each(
    function () { 
      
      var linkAttr = $(this).find('.slide-image').attr('data-href');
      if (typeof linkAttr !== typeof undefined && linkAttr !== false) {
        // Element has this attribute
        //console.log('empty');
        $(this).find('.slide-image').removeAttr('data-href');
      }
      
      //console.log(x);
    }
  );
  
  
});

